import {
  TableCellProps,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router';
import { IDocumentUnscoped } from '../../../types/my-types';
import { DocumentDetailsParamTypes } from '../../../pages/DocumentDetailsPage';

import TableStyles from '../Table.module.css';

import { TableCellStyled, TableContainerStyled, TypographySmallTitle } from './DocumentDetailsLeft';

interface IPackageListProps {
  documentData: IDocumentUnscoped;
}

const PackageList = ({ documentData }: IPackageListProps) => {
  const { documentId } = useParams<DocumentDetailsParamTypes>();

  if (!documentId) {
    return null;
  }

  // FIXME: Needs to pull real data
  const samplePackages = [
    { date: '2023-10-01', name: 'Sample Name 1' },
    { date: '2023-10-01', name: 'Sample Name 2' },
  ];

  return (
    // <div style={{ marginTop: '20px' }}>
    //   <TypographySmallTitle>PACKAGES</TypographySmallTitle>
    //   <TableContainerStyled>
    //     <Table>
    //       <TableHead>
    //         <TableRow>
    //           <TableCellStyled className={TableStyles.documentsTableHead}>Name</TableCellStyled>
    //           <TableCellStyled className={TableStyles.documentsTableHead}>Date</TableCellStyled>
    //         </TableRow>
    //       </TableHead>
    //       <TableBody>
    //         {samplePackages.map((packageUsed, index) => (
    //           <TableRow key={index}>
    //             <TableCellStyled>{packageUsed.name}</TableCellStyled>
    //             <TableCellStyled>{packageUsed.date}</TableCellStyled>
    //           </TableRow>
    //         ))}
    //       </TableBody>
    //     </Table>
    //   </TableContainerStyled>
    // </div>
    <></>
  );
};

export default PackageList;
